export const invalidNames = [
  'simular',
  'simulador',
  'credihome',
  'loft',
  'chl',
  'chl-loft',
  'labeless',
  'whitelabel',
  'white-label',
  'financiar',
  'home',
  'index',
];
